export const ROLE_TYPES = {
  ui: 'ui',
  api: 'api',
};
